import type { ButtonHTMLAttributes, FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";

export type EditActionProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const EditAction: FunctionComponent<EditActionProps> = ({
  className,
  ...buttonProps
}) => (
  <button {...buttonProps} type="button" className={className}>
    <FormattedMessage id="actions.edit" />
  </button>
);
